import React from 'react';

const GrievanceProcessProgress = ({ currentStatus }) => {
    const statuses = ['Logged', 'Assigned', 'In Progress', 'Resolved', 'Closed'];
    const currentIndex = statuses.indexOf(currentStatus) !== -1 ? statuses.indexOf(currentStatus) : 2;

    return (
        <div className="grievance-process-progress">
            <h5>Grievance Process Progress</h5>
            <div className="timeline">
                {statuses.map((status, index) => {
                    const isCompleted = index < currentIndex;
                    const isActive = index === currentIndex;
                    const isPending = index > currentIndex;

                    let pointClass = 'timeline-point';
                    if (isCompleted) pointClass += ' completed';
                    if (isActive) pointClass += ' active';

                    return (
                        <div className="timeline-item" key={index}>
                            <div className={pointClass}></div>
                            <div className="timeline-content">
                                <span className="title">{status}</span>
                                {isPending && <span className="status">Pending</span>}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default GrievanceProcessProgress;
